export const formatCount = (count: number): string => {
  if (count < 1000) {
    return count.toString();
  }
  const countInK = count / 1000;
  // For numbers < 10k, use up to one decimal (1.1k, 2k, etc)
  if (countInK < 10) {
    return `${countInK.toPrecision(2).replace(/\.0+$/, '')}k`;
  }
  // For numbers >= 10k, show one decimal if not a round number
  if (count % 1000 !== 0) {
    return `${(count / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  }
  return `${count / 1000}k`;
};
